import { Badge, Theme } from '@pga/pga-component-library'
import React from 'react'
import FaFilter from 'react-icons/lib/fa/filter'
import { connectStateResults } from 'react-instantsearch/connectors'
import MediaQuery from 'react-responsive'
import styled from 'styled-components'
import CloseSvgIcon from '../../../assets/icons/x.svg'
import FilterClear from './FilterClear'
import { getFiltersCount } from './utils'

const FilterHeaderContainer = styled.div`
  margin-bottom: 20px;
`

const FilterHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  align-items: flex-start;

  @media (min-width: 992px) {
    flex-direction: row;
    align-items: center;
  }
`

export const FilterTitle = styled.h4`
  font-family: ${Theme.fonts.Montserrat};
  font-weight: 500;
  text-align: left;
  color: ${Theme.colors.primary};
  font-size: 20px;
  margin-bottom: 0px;
  margin-right: 10px;

  @media (min-width: 992px) {
    font-weight: bold;
    color: ${Theme.colors.primary};
    font-size: 18px;
    margin-bottom: 0px;
    margin-right: 10px;
  }
`

export const FilterIcon = styled(FaFilter)`
  margin-right: 10px;
`

const FilterBadge = styled(Badge)`
  margin: 0;
`

const SearchResults = styled.div`
  font-family: ${Theme.fonts.Montserrat};
  color: ${Theme.colors.blueGrey};
  font-weight: 500;
  font-size: 12px;

  @media (min-width: 992px) {
    justify-self: flex-end;
    margin-left: auto;
  }
`

const ClearRefinementsWrapper = styled.div`
  display: flex;
`

export const RefinementBadge = ({ searchState }) => {
  const numberOfRefinements = getFiltersCount(searchState)

  return (
    numberOfRefinements
      ? <FilterBadge color={Theme.colors.gold}>{numberOfRefinements}</FilterBadge>
      : null
  )
}

export const SearchResultText = ({ searchResults }) => (
  <SearchResults>{searchResults && searchResults.nbHits} results</SearchResults>
)

const CloseIcon = styled.div`
  margin-left: 15px;
  background-image: url(${CloseSvgIcon});
  width: 21px;
  height: 20px;
  cursor: pointer;
`

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const FilterHeader = ({
  onChange,
  searchState,
  searchResults,
  toggle,
  onSearchStateChange
}) => {
  return (
    <FilterHeaderContainer>
      <FilterHeaderWrapper>
        <MediaQuery maxWidth={991}>
          <TitleWrapper>
            <FilterTitle>Filter Your Results</FilterTitle>
            <CloseIcon size={18} onClick={toggle} />
          </TitleWrapper>
          <SearchResultText searchResults={searchResults} />
        </MediaQuery>
        <MediaQuery minWidth={992}>
          <FilterIcon />
          <FilterTitle>Filter</FilterTitle>
          <RefinementBadge searchState={searchState} />
          <SearchResultText searchResults={searchResults} />
        </MediaQuery>
      </FilterHeaderWrapper>
      <ClearRefinementsWrapper>
        <FilterClear
          searchState={searchState}
          onSearchStateChange={onSearchStateChange}
        />
      </ClearRefinementsWrapper>
    </FilterHeaderContainer>
  )
}

export default connectStateResults(FilterHeader)
